import {setupFrontend} from '@macmillanplatform/ui-core/configured';

import {
  APPLICATION_NAME,
  CSRF_COOKIE_NAME,
  GOOGLE_ANALYTICS_CODE,
  SENTRY_TRACKING_URL,
  SPINNER_LOGO,
  WIDGET_ID,
  apiHost,
  env,
  isDevelopment,
} from '../constants';
import type {ConfiguredConfig} from '../types';

const CONFIG: ConfiguredConfig = {
  env,
  isDevelopment,
  widgetId: WIDGET_ID,
  spinnerLogo: SPINNER_LOGO,
  appName: APPLICATION_NAME,
  apiHost,
  csrfCookieName: CSRF_COOKIE_NAME,
  sentryTrackingUrl: SENTRY_TRACKING_URL,
  googleAnalyticsCode: GOOGLE_ANALYTICS_CODE,
};

const {utils, components} = setupFrontend(CONFIG);

export {utils, components};
